type TStreamEvent = {
  delta?: string;
  message?: string;
  type?: string;
};

const DONE = '[DONE]';

const BLOCK_SEPARATOR = /\r?\n\r?\n/;

const getEventData = (block: string): string | undefined => {
  const lines = block
    .split(/\r?\n/)
    .filter((line) => line.startsWith('data:'))
    .map((line) => line.slice(5).replace(/^ /, ''));

  return lines.length ? lines.join('\n') : undefined;
};

export const consumeStream = async (
  body: ReadableStream<Uint8Array>,
  onDelta: (content: string) => void,
): Promise<string> => {
  const reader = body.getReader();
  const decoder = new TextDecoder();

  let buffer = '';
  let content = '';

  const handleBlock = (block: string) => {
    const data = getEventData(block);

    if (!data || data === DONE) return;

    const event = JSON.parse(data) as TStreamEvent;

    if (event.type === 'error') throw new Error(event.message);
    if (event.type !== 'text_delta' || !event.delta) return;

    content += event.delta;
    onDelta(content);
  };

  for (;;) {
    const { done, value } = await reader.read();

    if (value) buffer += decoder.decode(value, { stream: !done });

    let separator = buffer.search(BLOCK_SEPARATOR);

    while (separator !== -1) {
      handleBlock(buffer.slice(0, separator));
      buffer = buffer.slice(separator).replace(BLOCK_SEPARATOR, '');
      separator = buffer.search(BLOCK_SEPARATOR);
    }

    if (done) break;
  }

  if (buffer.trim()) handleBlock(buffer);

  return content;
};
